export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents a page slug, encoded as a string with a restricted URL-safe alphabet. */
  Slug: any;
  /** Date custom scalar type */
  DateTime: any;
  /** Represents a monetary value in cents to avoid floating point problems, encoded as number. */
  MonetaryValue: any;
  /** Represents a currency code, encoded as string. */
  CurrencyCode: any;
  /** Represents the ID for a leaderboard, as a string. */
  LeaderboardId: any;
  /** Represents a page preview flag, as a boolean. */
  Preview: any;
  /** Represents a URL, encoded as string */
  URL: any;
};

export type Account = {
  __typename?: 'Account';
  startDate?: Maybe<Scalars['DateTime']>;
  connectionStatus: AccountConnectionStatus;
  timeRemaining?: Maybe<AccountConnectionTimeline>;
};

export enum AccountConnectionStatus {
  Unfunded = 'UNFUNDED',
  Initialised = 'INITIALISED',
  Reminded = 'REMINDED',
  Frozen = 'FROZEN',
  ElevatedFrozen = 'ELEVATED_FROZEN',
  PseudoSuspended = 'PSEUDO_SUSPENDED',
  Deactivated = 'DEACTIVATED',
  Connected = 'CONNECTED',
  Verified = 'VERIFIED',
  PendingVerification = 'PENDING_VERIFICATION',
  ManualVerification = 'MANUAL_VERIFICATION',
}

export type AccountConnectionTimeline = {
  __typename?: 'AccountConnectionTimeline';
  next?: Maybe<TimeRemaining>;
  final?: Maybe<TimeRemaining>;
};

export type AggregationRule = {
  __typename?: 'AggregationRule';
  segment: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  timeBox?: Maybe<TimeBox>;
};

export type Application = FitnessApplication;

export enum ApplicationType {
  Fitness = 'FITNESS',
}

export type BeneficiaryConnection = {
  __typename?: 'BeneficiaryConnection';
  edges: Array<BeneficiaryEdge>;
  nodes: Array<BeneficiaryItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BeneficiaryEdge = {
  __typename?: 'BeneficiaryEdge';
  cursor: Scalars['String'];
  node: BeneficiaryItem;
};

export type BeneficiaryItem = Charity | User;

export type Branding = {
  __typename?: 'Branding';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export type Charity = Node & {
  __typename?: 'Charity';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  slug: Scalars['Slug'];
  profilePageUrl?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['URL']>;
  impactStatement?: Maybe<Scalars['String']>;
  causeId?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['URL']>;
};

export type ConnectFitnessInput = {
  code?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type CreateEventInput = {
  title: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  activities: Array<FitnessApplicationActivityType>;
  externalFitnessSources: Array<ExternalFitnessSources>;
  allowManualActivities: Scalars['Boolean'];
  fundraiserFitnessGoal: FitnessGoalInput;
};

export type CreateLivestreamInput = {
  pageType: PageType;
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
};

export type CreateTimelineEntryInput = {
  type: PageType;
  pageId: Scalars['ID'];
  pageSlug?: Maybe<Scalars['Slug']>;
  creatorGuid?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCollectionInput>;
  fitness?: Maybe<FitnessActivityInput>;
};

export type CreatorInput = {
  displayName?: Maybe<Scalars['String']>;
};

export type DeleteLivestreamInput = {
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  positionId: Scalars['Int'];
};

export enum DeleteStatus {
  Success = 'SUCCESS',
  Fail = 'FAIL',
}

export type DeleteTimelineEntryInput = {
  id: Scalars['ID'];
};

export type Distance = {
  __typename?: 'Distance';
  unit: DistanceUnit;
  value: Scalars['Int'];
};

export enum DistanceUnit {
  Metres = 'METRES',
  Feet = 'FEET',
}

export type Donation = {
  __typename?: 'Donation';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  creationDate: Scalars['DateTime'];
  amount?: Maybe<MonetaryAmount>;
  giftAidAmount?: Maybe<MonetaryAmount>;
  displayName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['URL']>;
  message?: Maybe<Scalars['String']>;
  matches: Array<DonationMatch>;
  pageOwnerReaction?: Maybe<Reaction>;
};

export type DonationConnection = {
  __typename?: 'DonationConnection';
  edges: Array<DonationEdge>;
  nodes: Array<Donation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DonationEdge = {
  __typename?: 'DonationEdge';
  cursor: Scalars['String'];
  node: Donation;
  direct: Scalars['Boolean'];
};

export type DonationMatch = {
  __typename?: 'DonationMatch';
  type: DonationMatchType;
  amount: MonetaryAmount;
};

export enum DonationMatchType {
  GiftAid = 'GIFT_AID',
  CompanyContribution = 'COMPANY_CONTRIBUTION',
}

export type DonationSummary = {
  __typename?: 'DonationSummary';
  totalAmount?: Maybe<MonetaryAmount>;
  totalMatched: Array<DonationMatch>;
  onlineAmount?: Maybe<MonetaryAmount>;
  offlineAmount?: Maybe<MonetaryAmount>;
  textDonations?: Maybe<MonetaryAmount>;
  directDonationAmount?: Maybe<MonetaryAmount>;
  fundraiserRaisedAmount?: Maybe<MonetaryAmount>;
  donationCount?: Maybe<Scalars['Int']>;
  aggregatedDonationsCount?: Maybe<Scalars['Int']>;
};

export type Duration = {
  __typename?: 'Duration';
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type Event = Node & {
  __typename?: 'Event';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  externalFitnessSources?: Maybe<Array<ExternalFitnessSources>>;
  allowManualActivities?: Maybe<Scalars['Boolean']>;
  fundraiserGoals?: Maybe<Array<Goal>>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventEdge>;
  nodes: Array<Event>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export enum ExternalFitnessSources {
  Strava = 'STRAVA',
}

export type FitnessActivity = {
  __typename?: 'FitnessActivity';
  /** @deprecated Use `activityId` as it matches the property name of the model and `id` can be confused as a `Node.ID`. */
  id?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  activityType?: Maybe<FitnessApplicationActivityType>;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Distance>;
  elevation?: Maybe<Distance>;
  duration?: Maybe<Duration>;
};

export type FitnessActivityDistanceArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityElevationArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityDurationArgs = {
  unit?: Maybe<TimeUnit>;
};

export type FitnessActivityInput = {
  title: Scalars['String'];
  activityType: FitnessApplicationActivityType;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Int']>;
  elevation?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
};

export type FitnessApplication = {
  __typename?: 'FitnessApplication';
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<FitnessApplicationSettings>;
};

/** Fitness applications */
export enum FitnessApplicationActivityType {
  Run = 'RUN',
  Ride = 'RIDE',
  Walk = 'WALK',
  Hike = 'HIKE',
  Swim = 'SWIM',
}

export type FitnessApplicationSettings = {
  __typename?: 'FitnessApplicationSettings';
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
};

export type FitnessApplicationSettingsInput = {
  pageId: Scalars['ID'];
  name: Scalars['String'];
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
};

export type FitnessGoal = {
  __typename?: 'FitnessGoal';
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  targetMetric?: Maybe<TargetMetric>;
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

export type FitnessGoalInput = {
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure: UnitOfMeasure;
};

export type Funds = {
  __typename?: 'Funds';
  accounts?: Maybe<Array<Account>>;
  withdrawals?: Maybe<WithdrawalConnection>;
};

export type FundsInput = {
  type?: Maybe<PageType>;
  slug?: Maybe<Scalars['Slug']>;
};

export type Goal = FitnessGoal;

export type Hero = {
  __typename?: 'Hero';
  imageUrl?: Maybe<Scalars['URL']>;
  imageTitle?: Maybe<Scalars['String']>;
};

export type HeroInput = {
  url: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ImageMedia = Node & {
  __typename?: 'ImageMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export type ImageMediaInput = {
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  id: Scalars['LeaderboardId'];
  definition?: Maybe<LeaderboardDefinition>;
  totals: Array<LeaderboardTotal>;
};

export type LeaderboardTotalsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type LeaderboardDefinition = {
  __typename?: 'LeaderboardDefinition';
  segment: Scalars['String'];
  measurementDomain: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  primaryUnit: Scalars['String'];
  tagDefinition: TagDefinition;
  conditions: Array<Tag>;
};

export type LeaderboardTotal = {
  __typename?: 'LeaderboardTotal';
  tagValue: Scalars['String'];
  tagValueAsNode?: Maybe<Node>;
  amounts: Array<TotalAmount>;
};

export type Livestream = {
  __typename?: 'Livestream';
  pageType?: Maybe<PageType>;
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  entries?: Maybe<Array<Maybe<LivestreamEntries>>>;
};

export type LivestreamEntries = {
  __typename?: 'LivestreamEntries';
  mediaType?: Maybe<Scalars['String']>;
  streamId?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  positionId?: Maybe<Scalars['Int']>;
  isLive?: Maybe<Scalars['Boolean']>;
};

export type Location = {
  __typename?: 'Location';
  name?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export enum MeasurementSystem {
  Metric = 'METRIC',
  Imperial = 'IMPERIAL',
}

export type Media = ImageMedia | VideoMedia;

export type MediaCollectionInput = {
  imageMedia?: Maybe<Array<ImageMediaInput>>;
  videoMedia?: Maybe<Array<VideoMediaInput>>;
};

export type MediaConnection = {
  __typename?: 'MediaConnection';
  edges: Array<MediaEdge>;
  nodes: Array<Media>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MediaEdge = {
  __typename?: 'MediaEdge';
  cursor: Scalars['String'];
  node: Media;
};

export type Meta = {
  __typename?: 'Meta';
  releaseVersion: Scalars['String'];
};

/** Combines a monetary value with a currency code. */
export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  value: Scalars['MonetaryValue'];
  currencyCode: Scalars['CurrencyCode'];
};

export type MonetaryAmountInput = {
  value: Scalars['MonetaryValue'];
  currencyCode?: Maybe<Scalars['CurrencyCode']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * **DEPRECATED**
   * `saveFitnessApplicationSettings` Mutation is deprecated as of 26/05/2020. Use `setFitnessApplicationSettings` instead.
   */
  saveFitnessApplicationSettings?: Maybe<Scalars['Boolean']>;
  setFitnessApplicationSettings?: Maybe<FitnessApplicationSettings>;
  /** Sends a message to a donor to say thanks. */
  thankDonor?: Maybe<Donation>;
  createEvent?: Maybe<Event>;
  connectFitness: Scalars['Boolean'];
  disconnectFitness: Scalars['Boolean'];
  /** Create a new livestream entry */
  createLivestreamEntry?: Maybe<Livestream>;
  /** Delete a livestream entry */
  deleteLivestreamEntry?: Maybe<Livestream>;
  /** Update a livestream entry */
  updateLivestreamEntry?: Maybe<Livestream>;
  updatePage?: Maybe<Page>;
  completeTask?: Maybe<Tasks>;
  /** Create a new timeline entry */
  createTimelineEntry?: Maybe<TimelineEntry>;
  deleteTimelineEntry: Scalars['ID'];
  refreshTimelineEntry: Scalars['ID'];
};

export type MutationSaveFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationSetFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationThankDonorArgs = {
  donorId: Scalars['String'];
  pageId: Scalars['String'];
  message: Scalars['String'];
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationConnectFitnessArgs = {
  input: ConnectFitnessInput;
};

export type MutationCreateLivestreamEntryArgs = {
  input: CreateLivestreamInput;
};

export type MutationDeleteLivestreamEntryArgs = {
  input: DeleteLivestreamInput;
};

export type MutationUpdateLivestreamEntryArgs = {
  input: UpdateLivestreamInput;
};

export type MutationUpdatePageArgs = {
  input: PageInput;
};

export type MutationCompleteTaskArgs = {
  input?: Maybe<TaskInput>;
};

export type MutationCreateTimelineEntryArgs = {
  input: CreateTimelineEntryInput;
};

export type MutationDeleteTimelineEntryArgs = {
  input: DeleteTimelineEntryInput;
};

export type MutationRefreshTimelineEntryArgs = {
  input: RefreshTimelineEntryInput;
};

/** Marks an entity as being fetchable by its ID. */
export type Node = {
  id: Scalars['ID'];
};

export type Page = Node & {
  __typename?: 'Page';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  type: PageType;
  slug: Scalars['Slug'];
  url: Scalars['URL'];
  avatar?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  story?: Maybe<Scalars['String']>;
  reason?: Maybe<Reason>;
  joinVerb?: Maybe<Scalars['String']>;
  joinUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `hero` as it has `imageTitle` so you can set an image Alt. */
  heroImage?: Maybe<Scalars['URL']>;
  /** @deprecated Deprecated Nov 2019 - `hero` has been replaced by `heroMedia`. This allows a media type to be set, and to provide consistency with the `mediaCollection` field */
  hero?: Maybe<Hero>;
  heroMedia?: Maybe<Media>;
  /** @deprecated Use `targetWithCurrency.value` this will evetually become `target.value` */
  target?: Maybe<Scalars['MonetaryValue']>;
  /** @deprecated Use `targetWithCurrency.currencyCode` this will evetually become `target.currencyCode` */
  currency?: Maybe<Scalars['String']>;
  targetWithCurrency?: Maybe<MonetaryAmount>;
  donationSummary?: Maybe<DonationSummary>;
  membershipPolicy?: Maybe<Scalars['String']>;
  status?: Maybe<PageStatus>;
  createDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  updateDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  owner?: Maybe<User>;
  categories?: Maybe<Array<Scalars['String']>>;
  branding?: Maybe<Branding>;
  relationships?: Maybe<PageRelationships>;
  donations?: Maybe<DonationConnection>;
  timeline?: Maybe<TimelineEntryConnection>;
  mediaCollection?: Maybe<MediaConnection>;
  eventGivingGroupId?: Maybe<Scalars['Int']>;
  application?: Maybe<Application>;
  tags?: Maybe<Array<TagValue>>;
  redirectUrl?: Maybe<Scalars['String']>;
  livestream?: Maybe<Livestream>;
  startFundraisingUrl?: Maybe<Scalars['String']>;
  totals?: Maybe<PageTotals>;
};

export type PageDonationsArgs = {
  direct?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageTimelineArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type PageMediaCollectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageApplicationArgs = {
  name: Scalars['String'];
  type: ApplicationType;
};

/** Pagination page information. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the first edge on the current page. */
  startCursor?: Maybe<Scalars['String']>;
  /** The cursor for the last edge on the current page. */
  endCursor?: Maybe<Scalars['String']>;
  /** `true` if it is possible to navigate to the next page. */
  hasNextPage: Scalars['Boolean'];
  /** `true` if it is possible to navigate to the previous page. */
  hasPreviousPage: Scalars['Boolean'];
};

export type PageInput = {
  id?: Maybe<Scalars['ID']>;
  slug: Scalars['Slug'];
  type: PageType;
  title?: Maybe<Scalars['String']>;
  hero?: Maybe<HeroInput>;
  story?: Maybe<StoryInput>;
  reason?: Maybe<ReasonInput>;
  creator?: Maybe<CreatorInput>;
  owner?: Maybe<Scalars['ID']>;
  target?: Maybe<MonetaryAmountInput>;
  category?: Maybe<Scalars['String']>;
  beneficiaryIds?: Maybe<Array<Scalars['ID']>>;
  relatedPages?: Maybe<Array<RelatedPageInput>>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type PageRelationshipConfig = {
  __typename?: 'PageRelationshipConfig';
  membersDisabled: Scalars['Boolean'];
};

export type PageRelationshipConnection = {
  __typename?: 'PageRelationshipConnection';
  edges: Array<PageRelationshipEdge>;
  nodes: Array<Page>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PageRelationshipEdge = {
  __typename?: 'PageRelationshipEdge';
  cursor: Scalars['String'];
  node: Page;
};

export type PageRelationships = {
  __typename?: 'PageRelationships';
  beneficiaries: BeneficiaryConnection;
  members: PageRelationshipConnection;
  teams: PageRelationshipConnection;
  events: EventConnection;
  campaigns: PageRelationshipConnection;
  companies: PageRelationshipConnection;
  config?: Maybe<PageRelationshipConfig>;
};

export type PageRelationshipsBeneficiariesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsMembersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsTeamsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCompaniesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum PageStatus {
  Hidden = 'HIDDEN',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Offline = 'OFFLINE',
  PendingApproval = 'PENDING_APPROVAL',
  Inactive = 'INACTIVE',
}

/** A single amount/metric. */
export type PageTotal = {
  __typename?: 'PageTotal';
  /** The description/id of the amount. */
  measurementDomain: Scalars['String'];
  /** Conversions in various units, for the amount. */
  amounts: Array<TotalAmount>;
};

/** A collection of numeric totals captured from the Tags System. */
export type PageTotals = {
  __typename?: 'PageTotals';
  /** Specifies the list of totals to display. */
  displayOptions: PageTotalsDisplayOptions;
  /** Specifies the primary measurement type to display totals in. */
  primaryMeasurementType: Scalars['String'];
  /** A summary of fitness/activity amounts which are present on the page timeline. */
  timeline: Array<PageTotal>;
};

export enum PageTotalsDisplayOptions {
  DoNotDisplay = 'DO_NOT_DISPLAY',
  TimelineOnly = 'TIMELINE_ONLY',
}

export enum PageType {
  Crowdfunding = 'CROWDFUNDING',
  Fundraising = 'FUNDRAISING',
  Team = 'TEAM',
  Campaign = 'CAMPAIGN',
  Charity = 'CHARITY',
  Event = 'EVENT',
  Company = 'COMPANY',
}

export type Query = {
  __typename?: 'Query';
  /** Gets funds data */
  funds?: Maybe<Funds>;
  leaderboard: Leaderboard;
  livestream?: Maybe<Livestream>;
  meta: Meta;
  /** Gets page data by page type and slug */
  page?: Maybe<Page>;
  /** Gets page data by page type and id */
  pageById?: Maybe<Page>;
  /** Gets user data */
  viewer?: Maybe<User>;
  /** Gets node by id (node can anything that can be fetched by a unique global id, for example: page, user etc.) */
  node?: Maybe<Node>;
  tagValues: Array<TagValue>;
  tasks?: Maybe<Tasks>;
  totals: Array<Total>;
};

export type QueryFundsArgs = {
  input?: Maybe<FundsInput>;
};

export type QueryLeaderboardArgs = {
  id: Scalars['LeaderboardId'];
};

export type QueryLivestreamArgs = {
  legacyId: Scalars['String'];
};

export type QueryPageArgs = {
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryPageByIdArgs = {
  type: PageType;
  id: Scalars['String'];
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryTagValuesArgs = {
  assignee: Scalars['String'];
};

export type QueryTasksArgs = {
  input?: Maybe<TaskInput>;
};

export type QueryTotalsArgs = {
  segment: Scalars['String'];
  tagDefinitionId: Scalars['String'];
  tagValue: Scalars['String'];
  measurementDomain?: Maybe<Scalars['String']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  message: Scalars['String'];
};

export type Reason = {
  __typename?: 'Reason';
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Use `description` the naming is more indicative of what it actually is */
  reason?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  reasonUrl?: Maybe<Scalars['String']>;
};

export type ReasonInput = {
  icon?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RefreshTimelineEntryInput = {
  id: Scalars['ID'];
};

export type RelatedPageInput = {
  id: Scalars['ID'];
  type: RelatedPageType;
};

export enum RelatedPageType {
  RaisesMoneyFor = 'RAISES_MONEY_FOR',
  HasBeneficiary = 'HAS_BENEFICIARY',
}

export type StoryInput = {
  content: Scalars['String'];
  type: StoryType;
};

export enum StoryType {
  RichStoryV1Json = 'RICH_STORY_V1_JSON',
  Plaintext = 'PLAINTEXT',
  Html = 'HTML',
}

export type Strava = {
  __typename?: 'Strava';
  isConnected?: Maybe<Scalars['Boolean']>;
};

export type Tag = {
  __typename?: 'Tag';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
};

export type TagDefinition = {
  __typename?: 'TagDefinition';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type TagValue = {
  __typename?: 'TagValue';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  aggregation: Array<AggregationRule>;
};

export type TagWithNode = {
  __typename?: 'TagWithNode';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  valueAsNode?: Maybe<Node>;
};

export enum TargetMetric {
  Distance = 'DISTANCE',
  Elevation = 'ELEVATION',
  Duration = 'DURATION',
}

export type TaskInput = {
  type: PageType;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
};

export type Tasks = {
  __typename?: 'Tasks';
  completed: Array<Maybe<Scalars['String']>>;
};

export type ThirdPartyApplications = {
  __typename?: 'ThirdPartyApplications';
  strava?: Maybe<Strava>;
};

export type TimeBox = {
  __typename?: 'TimeBox';
  notBefore?: Maybe<Scalars['DateTime']>;
  notAfter?: Maybe<Scalars['DateTime']>;
};

export type TimelineEntry = Node & {
  __typename?: 'TimelineEntry';
  fitnessActivity?: Maybe<FitnessActivity>;
  refreshRequestedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media>>;
  type: TimelineEntryType;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type TimelineEntryConnection = {
  __typename?: 'TimelineEntryConnection';
  edges: Array<TimelineEntryEdge>;
  nodes: Array<TimelineEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TimelineEntryEdge = {
  __typename?: 'TimelineEntryEdge';
  cursor: Scalars['String'];
  node: TimelineEntry;
};

export enum TimelineEntryType {
  Manual = 'MANUAL',
  Fitness = 'FITNESS',
}

export type TimeRemaining = {
  __typename?: 'TimeRemaining';
  days?: Maybe<Scalars['Int']>;
};

export enum TimeUnit {
  Milliseconds = 'MILLISECONDS',
  Seconds = 'SECONDS',
}

export type Total = {
  __typename?: 'Total';
  segment: Scalars['String'];
  segmentAsNode?: Maybe<Node>;
  tag: TagWithNode;
  measurementDomain: Scalars['String'];
  amounts: Array<TotalAmount>;
};

export type TotalAmount = {
  __typename?: 'TotalAmount';
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export enum UnitOfMeasure {
  Metres = 'METRES',
  Kilometres = 'KILOMETRES',
  Feet = 'FEET',
  Miles = 'MILES',
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  FeetClimbed = 'FEET_CLIMBED',
  MetresClimbed = 'METRES_CLIMBED',
}

export type UpdateLivestreamInput = {
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
  positionId: Scalars['Int'];
};

export type User = Node & {
  __typename?: 'User';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  thirdPartyApplications?: Maybe<ThirdPartyApplications>;
};

export type UserInput = {
  name?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
};

export type VideoMedia = Node & {
  __typename?: 'VideoMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
};

export type VideoMediaInput = {
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  gross: MonetaryAmount;
  net: MonetaryAmount;
  platformFee: MonetaryAmount;
  processingFee: MonetaryAmount;
  status: WithdrawalStatus;
  completionDate?: Maybe<Scalars['DateTime']>;
  requestDate: Scalars['DateTime'];
};

export type WithdrawalConnection = {
  __typename?: 'WithdrawalConnection';
  nodes?: Maybe<Array<Withdrawal>>;
  status?: Maybe<Scalars['String']>;
  availabilityDate?: Maybe<Scalars['DateTime']>;
  totalAvailable: MonetaryAmount;
  totalWithdrawn: MonetaryAmount;
};

export enum WithdrawalStatus {
  Processing = 'PROCESSING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
}

export type AboutCampaignAndCharityQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  withExternalUrl: Scalars['Boolean'];
  beneficiariesLimit: Scalars['Int'];
};

export type AboutCampaignAndCharityQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & Pick<
                      Charity,
                      | 'id'
                      | 'name'
                      | 'description'
                      | 'logo'
                      | 'registrationNumber'
                      | 'profilePageUrl'
                      | 'externalUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'title' | 'url' | 'logo' | 'summary'
                  >
                >;
              };
          }
        >;
      }
  >;
};

export type CauseMiniFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
        BeneficiaryConnection,
        'totalCount'
      > & {
          nodes: Array<
            | ({ __typename?: 'Charity' } & Pick<
                Charity,
                | 'impactStatement'
                | 'id'
                | 'legacyId'
                | 'logo'
                | 'name'
                | 'profilePageUrl'
                | 'registrationNumber'
                | 'slug'
              >)
            | { __typename?: 'User' }
          >;
        };
      campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
        PageRelationshipConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Page' } & Pick<
              Page,
              'id' | 'url' | 'logo' | 'title' | 'summary'
            >
          >;
        };
    }
  >;
};

export type AboutTeamFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name' | 'avatar'>>;
};

export type AdminTabsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId'
>;

export type CampaignStartFundraisingFragment = { __typename?: 'Page' } & Pick<
  Page,
  'startFundraisingUrl' | 'status'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        config?: Maybe<
          { __typename?: 'PageRelationshipConfig' } & Pick<
            PageRelationshipConfig,
            'membersDisabled'
          >
        >;
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<
                  Charity,
                  'name' | 'profilePageUrl'
                >)
              | { __typename?: 'User' }
            >;
          };
      }
    >;
  };

export type CharityRegDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<Charity, 'registrationNumber'>)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type EndDateFragment = { __typename?: 'Page' } & Pick<Page, 'endDate'>;

export type DonationSummaryFragment = { __typename?: 'Page' } & {
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & {
      totalAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
      totalMatched: Array<
        { __typename?: 'DonationMatch' } & Pick<DonationMatch, 'type'> & {
            amount: { __typename?: 'MonetaryAmount' } & Pick<
              MonetaryAmount,
              'value' | 'currencyCode'
            >;
          }
      >;
      onlineAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
      offlineAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
      directDonationAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
      fundraiserRaisedAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
      textDonations?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >
      >;
    }
  >;
};

export type EncourageDonateOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name' | 'avatar'>>;
};

export type InactivityModalEventDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      events: { __typename?: 'EventConnection' } & Pick<
        EventConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Event' } & Pick<
              Event,
              'startDate' | 'endDate' | 'visible'
            >
          >;
        };
    }
  >;
};

export type EncourageShareOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name' | 'avatar'>>;
};

export type EventDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'joinUrl'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        events: { __typename?: 'EventConnection' } & Pick<
          EventConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Event' } & Pick<
                Event,
                'title' | 'startDate' | 'endDate' | 'visible'
              >
            >;
          };
      }
    >;
  };

export type FundraisersListQueryVariables = {
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
};

export type FundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<
                            User,
                            'avatar' | 'name'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'value' | 'currencyCode'
                              >
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type ManualFitnessEntrySettingsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId' | 'title' | 'type' | 'slug'
> & {
    application?: Maybe<
      { __typename?: 'FitnessApplication' } & {
        settings?: Maybe<
          { __typename?: 'FitnessApplicationSettings' } & Pick<
            FitnessApplicationSettings,
            'subscribedActivities' | 'measurementSystem'
          >
        >;
      }
    >;
  };

export type MembersListQueryVariables = {
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
};

export type MembersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'legacyId' | 'membershipPolicy'
    > & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'legacyId' | 'slug' | 'title' | 'status'
                  > & {
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<User, 'name' | 'avatar'>
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                    }
                >;
              };
          }
        >;
      }
  >;
};

export type MembersMiniFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId' | 'membershipPolicy'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        members: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Page' } & Pick<Page, 'id'> & {
                  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'avatar'>>;
                }
            >;
          };
      }
    >;
  };

export type PageOwnerAvatarFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name' | 'avatar'>>;
};

export type QualarooLoaderDocumentQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
};

export type QualarooLoaderDocumentQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'createDate' | 'endDate' | 'currency'
    > & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'name' | 'legacyId' | 'avatar'>
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & Pick<
            DonationSummary,
            'donationCount'
          > & {
              offlineAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
              totalAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
            }
        >;
        heroMedia?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'url'>)
          | { __typename?: 'VideoMedia' }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<
                { __typename?: 'Event' } & Pick<
                  Event,
                  'legacyId' | 'title' | 'startDate'
                >
              >;
            };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename?: 'Charity' } & Pick<Charity, 'legacyId'>)
                | { __typename?: 'User' }
              >;
            };
            campaigns: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
            teams: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
          }
        >;
        targetWithCurrency?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & {
            nodes: Array<
              { __typename?: 'Donation' } & Pick<Donation, 'creationDate'>
            >;
          }
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          >
        >;
        mediaCollection?: Maybe<
          { __typename?: 'MediaConnection' } & Pick<
            MediaConnection,
            'totalCount'
          >
        >;
      }
  >;
};

export type ReasonFragment = { __typename?: 'Page' } & {
  reason?: Maybe<
    { __typename?: 'Reason' } & Pick<Reason, 'icon' | 'reason' | 'reasonUrl'>
  >;
};

export type StickySummaryFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'avatar'>>;
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      campaigns: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'title'>>;
      };
    }
  >;
};

export type StoryFragment = { __typename?: 'Page' } & Pick<Page, 'story'>;

export type GetPageCampaignIdsQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
};

export type GetPageCampaignIdsQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            campaigns: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
          }
        >;
      }
  >;
};

export type GetStravaSettingsQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
};

export type GetStravaSettingsQuery = { __typename?: 'Query' } & {
  viewer?: Maybe<
    { __typename?: 'User' } & {
      thirdPartyApplications?: Maybe<
        { __typename?: 'ThirdPartyApplications' } & {
          strava?: Maybe<
            { __typename?: 'Strava' } & Pick<Strava, 'isConnected'>
          >;
        }
      >;
    }
  >;
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'title' | 'id'> & {
        strava?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                | 'showMap'
                | 'measurementSystem'
                | 'subscribedActivities'
                | 'showPhotos'
                | 'showDuration'
                | 'showDistance'
                | 'showElevation'
              >
            >;
          }
        >;
      }
  >;
};

export type SuccessMessageFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currencyCode'>
  >;
};

export type SupportersListQueryVariables = {
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
};

export type SupportersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'DonationEdge' } & {
                  node: { __typename?: 'Donation' } & Pick<
                    Donation,
                    | 'id'
                    | 'legacyId'
                    | 'creationDate'
                    | 'displayName'
                    | 'avatar'
                    | 'message'
                  > & {
                      amount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                      giftAidAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            }
        >;
      }
  >;
};

export type TeamAndCompanyFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      teams: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<
          { __typename?: 'Page' } & Pick<Page, 'title' | 'url' | 'status'> & {
              heroMedia?: Maybe<
                | ({ __typename?: 'ImageMedia' } & Pick<
                    ImageMedia,
                    'id' | 'url' | 'alt'
                  >)
                | ({ __typename?: 'VideoMedia' } & Pick<VideoMedia, 'id'>)
              >;
            }
        >;
      };
      companies: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<
          { __typename?: 'Page' } & Pick<Page, 'title' | 'url' | 'logo'>
        >;
      };
    }
  >;
};

export type TeamDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<
            { __typename?: 'Page' } & Pick<
              Page,
              'id' | 'legacyId' | 'title' | 'url' | 'status'
            >
          >;
        };
      }
    >;
  };

export type TeamsListQueryVariables = {
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
};

export type TeamsListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            teams: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug' | 'title'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<User, 'avatar'>
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'currencyCode' | 'value'
                              >
                            >;
                            totalMatched: Array<
                              { __typename?: 'DonationMatch' } & Pick<
                                DonationMatch,
                                'type'
                              > & {
                                  amount: {
                                    __typename?: 'MonetaryAmount';
                                  } & Pick<
                                    MonetaryAmount,
                                    'currencyCode' | 'value'
                                  >;
                                }
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type ShareModalFragment = { __typename?: 'Page' } & Pick<
  Page,
  'title'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'name'>)
              | { __typename?: 'User' }
            >;
          };
      }
    >;
  };

export type GetStravaDisplayPreferencesQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
};

export type GetStravaDisplayPreferencesQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        strava?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                | 'showMap'
                | 'measurementSystem'
                | 'subscribedActivities'
                | 'showPhotos'
                | 'showDuration'
                | 'showDistance'
                | 'showElevation'
              >
            >;
          }
        >;
      }
  >;
};

export type TimelineUpdateEditorFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'avatar'>>;
};

export type TotaliserWrapperFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & {
      totalAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
      >;
    }
  >;
};

export type TotalsFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<
      MonetaryAmount,
      'currencyCode' | 'value'
    >
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & Pick<
      DonationSummary,
      'aggregatedDonationsCount'
    > & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'currencyCode' | 'value'
          >
        >;
      }
  >;
  donations?: Maybe<
    { __typename?: 'DonationConnection' } & Pick<
      DonationConnection,
      'totalCount'
    >
  >;
};

export type WeDidItFragment = { __typename?: 'Page' } & Pick<
  Page,
  'endDate'
> & {
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'currencyCode' | 'value'
          >
        >;
      }
    >;
    donations?: Maybe<
      { __typename?: 'DonationConnection' } & Pick<
        DonationConnection,
        'totalCount'
      >
    >;
  };

export type ActivityTotalsFragment = { __typename?: 'Page' } & {
  totals?: Maybe<
    { __typename?: 'PageTotals' } & Pick<
      PageTotals,
      'displayOptions' | 'primaryMeasurementType'
    > & {
        timeline: Array<
          { __typename?: 'PageTotal' } & Pick<
            PageTotal,
            'measurementDomain'
          > & {
              amounts: Array<
                { __typename?: 'TotalAmount' } & Pick<
                  TotalAmount,
                  'unit' | 'value'
                >
              >;
            }
        >;
      }
  >;
  application?: Maybe<
    { __typename?: 'FitnessApplication' } & {
      settings?: Maybe<
        { __typename?: 'FitnessApplicationSettings' } & Pick<
          FitnessApplicationSettings,
          'measurementSystem'
        >
      >;
    }
  >;
};

export type MediaCollectionFragment = { __typename?: 'Page' } & {
  mediaCollection?: Maybe<
    { __typename?: 'MediaConnection' } & {
      nodes: Array<
        | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'id' | 'url'>)
        | { __typename?: 'VideoMedia' }
      >;
    }
  >;
};

export type ConnectFitnessMutationVariables = {
  input: ConnectFitnessInput;
};

export type ConnectFitnessMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'connectFitness'
>;

export type SetFitnessApplicationSettingsMutationVariables = {
  input: FitnessApplicationSettingsInput;
};

export type SetFitnessApplicationSettingsMutation = {
  __typename?: 'Mutation';
} & {
  setFitnessApplicationSettings?: Maybe<
    { __typename?: 'FitnessApplicationSettings' } & Pick<
      FitnessApplicationSettings,
      | 'measurementSystem'
      | 'subscribedActivities'
      | 'showDistance'
      | 'showDuration'
      | 'showElevation'
      | 'showPhotos'
      | 'showMap'
    >
  >;
};

export type RefreshTimelineEntryMutationVariables = {
  input: RefreshTimelineEntryInput;
};

export type RefreshTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'refreshTimelineEntry'
>;

export type CreateTimelineEntryMutationVariables = {
  input: CreateTimelineEntryInput;
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type CreateTimelineEntryMutation = { __typename?: 'Mutation' } & {
  createTimelineEntry?: Maybe<
    { __typename?: 'TimelineEntry' } & Pick<
      TimelineEntry,
      'id' | 'legacyId' | 'message' | 'type' | 'createdAt'
    > & {
        media?: Maybe<
          Array<
            | ({ __typename?: 'ImageMedia' } & Pick<
                ImageMedia,
                'id' | 'url' | 'legacyId'
              >)
            | { __typename?: 'VideoMedia' }
          >
        >;
        fitnessActivity?: Maybe<
          { __typename?: 'FitnessActivity' } & Pick<
            FitnessActivity,
            'activityId' | 'title' | 'activityType' | 'mapPolyline'
          > & {
              distance?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              elevation?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              duration?: Maybe<
                { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
              >;
            }
        >;
      }
  >;
};

export type DeleteTimelineEntryMutationVariables = {
  input: DeleteTimelineEntryInput;
};

export type DeleteTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'deleteTimelineEntry'
>;

export type ListTimelineEntriesQueryVariables = {
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type ListTimelineEntriesQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'> & {
        owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name' | 'avatar'>>;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          > & {
              nodes: Array<
                { __typename?: 'TimelineEntry' } & Pick<
                  TimelineEntry,
                  | 'id'
                  | 'legacyId'
                  | 'message'
                  | 'type'
                  | 'createdAt'
                  | 'refreshRequestedTime'
                > & {
                    media?: Maybe<
                      Array<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'id' | 'url' | 'legacyId'
                          >)
                        | { __typename?: 'VideoMedia' }
                      >
                    >;
                    fitnessActivity?: Maybe<
                      { __typename?: 'FitnessActivity' } & Pick<
                        FitnessActivity,
                        'activityId' | 'title' | 'activityType' | 'mapPolyline'
                      > & {
                          distance?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          elevation?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          duration?: Maybe<
                            { __typename?: 'Duration' } & Pick<
                              Duration,
                              'unit' | 'value'
                            >
                          >;
                        }
                    >;
                  }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
              >;
            }
        >;
      }
  >;
};

export type IsCharityAdminFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<Charity, 'legacyId'>)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type IsPageOwnerFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId'
> & { owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'legacyId'>> };

export type PageIdFragment = { __typename?: 'Page' } & Pick<Page, 'id'>;

export type FundraisingPageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'title' | 'eventGivingGroupId'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'name'>)
              | { __typename?: 'User' }
            >;
          };
        companies: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        >;
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'status'>>;
        };
      }
    >;
  };

export type BasePageDataQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  includeEvent?: Maybe<Scalars['Boolean']>;
};

export type BasePageDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      | 'id'
      | 'status'
      | 'legacyId'
      | 'title'
      | 'summary'
      | 'logo'
      | 'type'
      | 'url'
      | 'redirectUrl'
      | 'startFundraisingUrl'
      | 'joinUrl'
    > & {
        hero?: Maybe<
          { __typename?: 'Hero' } & Pick<Hero, 'imageUrl' | 'imageTitle'>
        >;
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        mediaCollection?: Maybe<
          { __typename?: 'MediaConnection' } & {
            nodes: Array<
              | ({ __typename?: 'ImageMedia' } & Pick<
                  ImageMedia,
                  'id' | 'url' | 'caption'
                >)
              | { __typename?: 'VideoMedia' }
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            events: { __typename?: 'EventConnection' } & Pick<
              EventConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Event' } & Pick<
                    Event,
                    'title' | 'startDate' | 'endDate' | 'visible'
                  >
                >;
              };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & Pick<
                      Charity,
                      'legacyId' | 'name' | 'profilePageUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
          }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'name' | 'legacyId'>
        >;
        reason?: Maybe<
          { __typename?: 'Reason' } & Pick<
            Reason,
            'icon' | 'reason' | 'reasonUrl'
          >
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            | 'primaryColor'
            | 'backgroundColor'
            | 'backgroundImage'
            | 'logo'
            | 'headerImage'
          >
        >;
      }
  >;
};

export type DonateDataQueryVariables = {
  type: PageType;
  slug: Scalars['Slug'];
};

export type DonateDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'eventGivingGroupId' | 'legacyId' | 'title' | 'slug'
    > & {
        heroMedia?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'url'>)
          | { __typename?: 'VideoMedia' }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'name' | 'avatar' | 'legacyId'>
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<Branding, 'primaryColor' | 'logo'>
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & {
            totalAmount?: Maybe<
              { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'currencyCode'
              >
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename?: 'Charity' } & Pick<
                    Charity,
                    'legacyId' | 'name' | 'logo' | 'causeId'
                  >)
                | { __typename?: 'User' }
              >;
            };
            campaigns: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
            teams: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'legacyId'>>;
            };
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<{ __typename?: 'Event' } & Pick<Event, 'legacyId'>>;
            };
          }
        >;
      }
  >;
};
